import { eStudyActionTypes } from "./types";
import { IStudy } from "../../model";

export const setStudy = (study: IStudy) => ({
  type: eStudyActionTypes.SET_STUDY,
  payload: study
});
